<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因调控/基因编辑/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .effect-lists{
    justify-content: flex-start!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>CRISPRa/CRISPRi服务</h1>
      <h2 class="mt10">CRISPRa/CRISPRi Service</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;color:#014492;font-weight:bold;">CRISPRa</p>
        <p class="desc">CRISPRa（CRISPR activation），也称为CRISPR激活，是一种协同激活的转录激活系统，其目的在于特定上调基因表达，其原理是利用dCas9-sgRNA (无核酸酶活性的Cas9)，将直接融合或间接结合的转录激活因子（如VP64）绑定到目标基因的启动子区域，强行激活转录。除此之外，还可对sgRNA进行修饰，使之可以募集额外的转录激活因子以达成协同激活作用。</p>
        <div class="gene_img con flex flex-justify-center" style="width: -moz-fit-content;width: fit-content;">
          <img src="@/assets/img/产品及服务/基因调控/基因编辑/CRISPRa.png"  style="margin-bottom: 20px;width: 60%">
        </div>
        <div class="gene_img cons flex flex-justify-center" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;">
          <img src="@/assets/img/产品及服务/基因调控/基因编辑/CRISPRa.png"  style="margin-bottom: 20px;width: 60%">
        </div>
        <p style="margin-top: 20px;">备注：修饰的sgRNA包含了两段发卡结构，该结构可以结合噬菌体MS2外壳蛋白二聚体。MS2蛋白可以与另外的活化剂（如p65）和人热休克因子1（HSF1）融合，使得每个dCas9分子可以募集13个活化分子，基因表达从10倍增加到几千倍。</p>
      </div>
      <div class="container">
        <div class="c-title">产品报价<small>Product quotation</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData1">
            <el-table-column
              prop="method1"
              label="产品类型">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="载体名称">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="产品规格">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="产品价格(元)">
            </el-table-column>
          </el-table>
        </div>
        <h3 style="margin-top: 30px;">备注：</h3>
        <h3 style="margin-top: 10px;">sgRNA-MS2表达质粒:<span style="font-weight:normal;">Lenti- sgRNA-2*PP7-2*MS2-Puro，编码特异性sgRNA及激活因子PP7-p65-HSF1</span> </h3>
        <h3 style="margin-top: 10px;">dCas9表达质粒:<span style="font-weight:normal;">Lenti-dCas9-VP64-Blast, 编码dCas9蛋白，并融合了转录活因子VP64</span> </h3>
        <h3 style="margin-top: 10px;">激活因子质粒:<span style="font-weight:normal;">MS2-p65-HSF1 (非必须)</span> </h3>
      </div>
      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">产品优点<small>Product advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/基因调控/基因编辑/critle.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.相较于传统基因过表达构建方法，CRISPRa不受基因长度的限制</p>
                <p class="mb20">2.对LncRNA和microRNA等非编码RNA有更好的转录激活效果</p>
                <p class="mb20">3.操作简单，价格更低，无需再进行全长ORF克隆。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">产品缺点<small>Product disadvantage</small></div>
        <p class="desc" style="margin-bottom: 50px;">激活的效率有限，对基因有几倍到上百倍的过表达，低于ORF过表达的效果，研究者可根据实际情况选择合适的过表达方案。</p>
        <p class="desc" style="margin-bottom: 20px;color:#014492;font-weight:bold;">CRISPRi</p>
        <!-- <div class="gene_img" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/基因调控/基因编辑/cirtie2.png"  style="margin-bottom: 20px;"></div> -->
        <p class="desc">CRISPRi是一种转录抑制系统，可特定下调基因表达，在这个系统中，dCas9与Kox1的转录阻遏物结构域KRAB（Krüppel-associated box）融合，结合靶向的sgRNA将直接融合或间接结合的抑制因子（如KRAB）绑定到目标基因的启动子区域，抑制转录。</p>
      </div>
      <div class="container">
        <div class="c-title">产品报价<small>Product quotation</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="产品类型">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="载体名称">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="产品规格">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="产品价格(元)">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;height: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData1:[
        {
          method1:'gRNA导向',
          method2:'单条sgRNA质粒',
          method3:'Lenti-μ6-sgRNA-2*PP7-2* MS2-PGK-Puro',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'gRNA导向',
          method2:'3个目的+NC sgRNA质粒',
          method3:'Lenti-μ6-sgRNA-2*PP7-2* MS2-PGK-Puro',
          method4:'4×5 μg',
          method5:'1800'
        },
        {
          method1:'gRNA导向',
          method2:'3个目的+NC sgRNA质粒',
          method3:'Lenti-μ6-sgRNA-2*PP7-2*MS2-PGK-Puro',
          method4:'4×50 μg (去内毒素质粒)',
          method5:'2800'
        },
        {
          method1:'dCas9-激活因子',
          method2:'dCas9-VP64质粒',
          method3:'Lenti- EF1-dCas9-VP64-2A-Blast',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'dCas9-激活因子',
          method2:'dCas9m4-VPR质粒',
          method3:'Lenti -CMV dCas9m4-VPR-EF1-NEO',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'dCas9-抑制辅助',
          method2:'dCas9-KRAB-MeCP2质粒',
          method3:'Lenti-CMV-dCas9- KRAB-MeCP2-EF1-EF1-NEO',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'MS2-激活因子',
          method2:'MS2-P65-HSF1_Hygro质粒',
          method3:'Lenti-EF1-MS2-P65-HSF1_2A_Hygro',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'MS2-激活因子',
          method2:'3MS2- P65-HSF1_EGFP 质粒',
          method3:'Lenti-EF1-MS2-P65-HSF1_EGFP',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'gRNA导向',
          method2:'慢病毒包装',
          method3:'Lenti-μ6-sgRNA-2*PP7-2* MS2-PGK-Puro',
          method4:'200 μL*5',
          method5:'1800'
        },
        {
          method1:'dCas9',
          method2:'慢病毒包装',
          method3:'dCas9辅助因子',
          method4:'200 μL*5',
          method5:'6800'
        },
        {
          method1:'转染试剂',
          method2:'Tsnanofect 转染试剂',
          method3:'',
          method4:'1000 μg',
          method5:'1250'
        }
      ],
      tableData: [
        {
          method1:'dCas9-抑制辅助',
          method2:'dCas9-KRAB-MeCP2质粒',
          method3:'Lenti-CMV-dCas9- KRAB-MeCP2-EF1-EF1-NEO',
          method4:'5 μg',
          method5:'800'
        },
        {
          method1:'gRNA导向',
          method2:'常规sgRNA质粒',
          method3:'Lenti CRISPR v2',
          method4:'5 μg',
          method5:'800'
        },
      ],
      currentType: -1,
      currentService: -1,
      types1: [
        {name: 'sgRNA合成', img: '1', ref: '/products/sgRNA_Synthesis'},
        {name: 'sgRNA质粒构建', img: '2', ref: '/products/sgRNA_plasmid_construction'},
        {name: 'sgRNA文库构建', img: '3', ref: '/products/sgRNA_library_construction'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/CRISPRi_CRISPRa_Applications.vue